// extracted by mini-css-extract-plugin
export default {"filingDecisionAmountDetails":"filingDecisionsAmountDetails_filingDecisionAmountDetails__XlKls"};